import { Link } from 'react-router-dom';
import React from 'react';
import { MessageFormatElement } from 'react-intl';
import { Badge } from 'antd';
import { RouterConfigData } from '@nxsys/types/models/Apps';

const renderMenuItemChildren = (
  item: RouterConfigData,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
  search: string,
) => {
  const { icon, messageId, url } = item;

  const text = messages[messageId] as string;
  const badge = item.count ? (
    <Badge count={item.count} size="small" style={{ marginLeft: 6 }} />
  ) : null;

  if (url && url.includes('/'))
    return {
      key: item.id,
      icon:
        icon &&
        (React.isValidElement(icon) ? (
          <span className="ant-menu-item-icon">{icon}</span>
        ) : (
          <span className="ant-menu-item-icon" />
        )),
      label: (
        <Link to={url + search}>
          <span data-testid={messageId?.toLowerCase() + '-nav'}>
            {text}
            {badge}
          </span>
        </Link>
      ),
    };
  else {
    return {
      key: item.id,
      icon:
        icon &&
        (React.isValidElement(icon) ? (
          <span className="ant-menu-item-icon">{icon}</span>
        ) : (
          <span className="ant-menu-item-icon" />
        )),
      label: (
        <span data-testid={messageId?.toLowerCase() + '-nav'}>
          {text}
          {badge}
        </span>
      ),
    };
  }
};

const renderMenuItem: any = (
  item: RouterConfigData,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
  search: string,
) => {
  return item.type === 'collapse'
    ? {
        ...renderMenuItemChildren(item, messages, search),
        children: item.children?.map((item) =>
          renderMenuItem(item, messages, search),
        ),
      }
    : {
        ...renderMenuItemChildren(item, messages, search),
      };
};

const renderMenu = (
  item: RouterConfigData,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
  search: string,
) => {
  if (item.type === 'divider') {
    return [{ type: 'divider' as const }];
  }
  if (item.type === 'group') {
    return (
      item.children?.map((child) => renderMenuItem(child, messages, search)) ??
      []
    );
  }
  if (item.type === 'collapse') {
    return [renderMenuItem(item, messages, search)];
  }
  return [
    {
      exact: item.exact,
      ...renderMenuItemChildren(item, messages, search),
    },
  ];
};

export const getRouteMenus = (
  routesConfig: RouterConfigData[],
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
  search: string,
) => {
  return routesConfig.flatMap((route) => renderMenu(route, messages, search));
};
